/** The Tasks groups, in order (CT-5722). Each shows this many rows before "Show N more". */
export const TASK_GROUPS = Object.freeze(['act_now', 'this_week', 'later']);
export const TASK_GROUP_PREVIEW = 3;

/** What a search over the tasks covers. */
export const TASK_SEARCH_FIELDS = Object.freeze(['title', 'description']);

/** The All filters dimension: the task type. Fixed product dimension, hence i18n keys. */
export const TASK_TYPES = Object.freeze(['next_best_action', 'suggestion', 'handoff', 'reply_needed', 'fact_check', 'task']);

/**
 * What each row action DOES, by action type — never by label or task type:
 *
 *   concierge   hand-off through `useConciergeHandoff` (CT-5721) with this intent
 *   nbaPanel    the Next Best Action slide-out (CT-5713), in this mode
 *   mutation    a task mutation (`useTaskAction`)
 *   external    a new tab on the payload's URL
 *   sandbox     the Knowledge tab's Sandbox, filtered to what is left to confirm
 */
export const TASK_ACTIONS = Object.freeze({
  review_draft: { kind: 'concierge', intent: 'review_draft' },
  answer: { kind: 'concierge', intent: 'answer' },
  reply: { kind: 'concierge', intent: 'reply' },
  review_workflow: { kind: 'nbaPanel', mode: 'journey' },
  take_over: { kind: 'mutation', mutation: 'take_over' },
  complete: { kind: 'mutation', mutation: 'complete' },
  open_external: { kind: 'external' },
  review_in_sandbox: { kind: 'sandbox' },
});

/** Whether a row hands off to the Concierge by itself (`TaskConciergeCard`) instead of through the page. */
export const isConciergeTask = (task) => TASK_ACTIONS[task?.action?.type]?.kind === 'concierge';

/** The tab kind "Review in Sandbox" leads to (Knowledge, CT-5717) and where in it. */
export const TASK_SANDBOX_TAB_KIND = 'KNOWLEDGE'; // TAB_KINDS.KNOWLEDGE (CT-5717)
export const TASK_SANDBOX_PATH = 'sandbox';
export const TASK_SANDBOX_SEARCH = '?status=to_confirm';
